import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Chip } from '@mui/material'
import React from 'react'
import useModals from 'src/Hooks/useModals'
import { getRfidChipColors, getRfidChipLabel, getRfidChipStatus } from '../../../advanced-settings/charging-stations'
import { SettingsBox } from 'src/Elements/Data'
import { BadgeDto } from '../types'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

interface BadgeProps {
  installationId: number
  badge: BadgeDto
}

/** User-level badges page to manage charging station badges */
export const Badge: React.FC<BadgeProps> = ({ installationId, badge }) => {
  const { t } = useCustomTranslation()

  const { openEditBadgeDialog } = useModals()
  const { hasInstallationWritingRights: userCanEdit } = useInstallationAccessRightsContext()

  const status = getRfidChipStatus(badge.expirationDate)
  const label = getRfidChipLabel(status, badge.expirationDate, t)
  const { color, bgcolor } = getRfidChipColors(status)

  const handleOpenEditEditor = (): void => {
    openEditBadgeDialog({
      installationId,
      initialBadge: badge,
    })
  }

  return (
    <SettingsBox
      title={badge.name ?? ''}
      description={`ID: ${badge.badgeId ?? ''}`}
      suffix={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: { xs: '100%', sm: 'auto' } }}>
          <Chip label={label} sx={{ color, bgcolor }} size="small" />
          <Button variant="contained" size="small" onClick={handleOpenEditEditor} disabled={!userCanEdit}>
            {t('common.edit')}
          </Button>
        </Box>
      }
    />
  )
}
